/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { get_data_painel, search_type } from 'store/modules/juridico_facil_store/actions';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import { ApplicationState } from 'store';
import { LegislationsOptions } from 'services/legislations';

import * as Shell from '../DrLicitaChat/styles';
import * as S from '../DrLicitaPeticoes/styles';
import * as J from './styles';
import Resultados from './Resultados';
import Detalhe from './Detalhe';

// Página "Jurisprudência Fácil" do Dr. Licita: busca do Jurídico Fácil (acervo
// curado + JusBrasil) com filtro por tribunal, resultados e detalhe próprios.
// O estado da busca vive na URL (?q, tipo, tribunais, page, item, fonte) para
// o voltar do navegador e o "voltar aos resultados" caírem no lugar certo.

const MODES = [
  { mode: 'peticao', title: 'Construir Petição', icon: 'edit_note' },
  { mode: 'duvidas', title: 'Dúvidas Jurídicas', icon: 'help_outline' },
  { mode: 'jurisprudencia', title: 'Jurisprudência Fácil', icon: 'gavel' },
];

const ROTA = '/dr_licita/jurisprudencia';

const DrLicitaJurisprudencia: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const areaRef = useRef<HTMLDivElement>(null);

  const { juridico } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  const params = new URLSearchParams(location.search);
  const termo = (params.get('q') || '').trim();
  const tipoDaUrl = Number(params.get('tipo') || 0);
  const pagina = Math.max(1, Number(params.get('page') || 1));
  const tribunaisParam = params.get('tribunais') || '';
  const tribunaisDaUrl = tribunaisParam.split(',').filter(Boolean);
  const itemAberto = params.get('item');
  const fonteAberta = params.get('fonte') || undefined;

  const [busca, setBusca] = useState(termo);
  const [tipo, setTipo] = useState(tipoDaUrl);
  // null = todos os tribunais marcados (estado inicial, antes de mexer)
  const [selecionados, setSelecionados] = useState<string[] | null>(
    tribunaisDaUrl.length ? tribunaisDaUrl : null,
  );
  const [mostrarFiltro, setMostrarFiltro] = useState(false);
  const [mostrarTces, setMostrarTces] = useState(false);

  const tribunais = juridico?.tribunais_para_index || [];
  const tces = tribunais.filter((item) => item.court.startsWith('TCE'));
  const demais = tribunais.filter((item) => !item.court.startsWith('TCE'));
  const marcados = selecionados ?? tribunais.map((item) => item.court);

  useEffect(() => {
    document.title = 'Dr Licita - Jurisprudência Fácil';
    dispatch(get_data_painel());
  }, []);

  // A busca segue a URL (inclui voltar/avançar do navegador)
  useEffect(() => {
    if (!termo) return;
    dispatch(
      search_type(
        {
          search: termo,
          tipo: tipoDaUrl,
          accept: false,
          video: false,
          ...(tribunaisDaUrl.length ? { tribunais: tribunaisDaUrl } : {}),
        },
        pagina,
      ),
    );
  }, [termo, tipoDaUrl, tribunaisParam, pagina]);

  useEffect(() => {
    setBusca(termo);
  }, [termo]);

  useEffect(() => {
    areaRef.current?.scrollTo({ top: 0 });
  }, [itemAberto, pagina]);

  const navegar = (mudancas: Record<string, string | undefined>) => {
    const proximos = new URLSearchParams(location.search);
    Object.entries(mudancas).forEach(([chave, valor]) => {
      if (valor) proximos.set(chave, valor);
      else proximos.delete(chave);
    });
    const query = proximos.toString();
    history.push(query ? `${ROTA}?${query}` : ROTA);
  };

  const pesquisar = () => {
    const novoTermo = busca.trim();
    if (!novoTermo || marcados.length === 0) return;
    setMostrarFiltro(false);
    navegar({
      q: novoTermo,
      tipo: tipo ? String(tipo) : undefined,
      // Todos marcados = sem filtro (a busca de sempre)
      tribunais: marcados.length < tribunais.length ? marcados.join(',') : undefined,
      page: undefined,
      item: undefined,
      fonte: undefined,
    });
  };

  const abrirItem = (id: number, fonte?: string) => navegar({ item: String(id), fonte });

  const alternar = (courts: string[], marcar: boolean) =>
    setSelecionados(
      marcar
        ? Array.from(new Set([...marcados, ...courts]))
        : marcados.filter((court) => !courts.includes(court)),
    );

  const formatar = (qnt: number) => qnt.toLocaleString('pt-BR');

  const renderTribunal = (item: {
    court: string;
    sigla: string;
    descricao: string;
    qnt: number;
  }) => (
    <li key={item.court}>
      <label>
        <input
          type="checkbox"
          checked={marcados.includes(item.court)}
          onChange={(event) => alternar([item.court], event.target.checked)}
        />
        {item.descricao} ({item.sigla})<small>{formatar(item.qnt)}</small>
      </label>
    </li>
  );

  // Filtro por tribunal + barra de busca: centralizados na tela inicial;
  // no topo, abaixo do breadcrumb, quando há resultados
  const renderBusca = () => (
    <>
      <Shell.InputRegion>
        {mostrarFiltro && tribunais.length > 0 && (
          <J.Tribunais>
            <J.Acoes>
              <button
                type="button"
                onClick={() => setSelecionados(tribunais.map((item) => item.court))}
              >
                Marcar todos
              </button>
              <span>•</span>
              <button type="button" onClick={() => setSelecionados([])}>
                Desmarcar todos
              </button>
            </J.Acoes>
            <J.Colunas>
              <ul>{demais.map(renderTribunal)}</ul>
              {tces.length > 0 && (
                <ul>
                  <li>
                    <label>
                      <input
                        type="checkbox"
                        checked={tces.every((item) => marcados.includes(item.court))}
                        onChange={(event) =>
                          alternar(
                            tces.map((item) => item.court),
                            event.target.checked,
                          )
                        }
                      />
                      Tribunais de Contas dos Estados (TCE)
                      <small>{formatar(tces.reduce((soma, item) => soma + item.qnt, 0))}</small>
                    </label>
                    <button
                      type="button"
                      className="link"
                      onClick={() => setMostrarTces(!mostrarTces)}
                    >
                      {mostrarTces ? 'Ocultar tribunais' : 'Selecionar tribunais'}
                    </button>
                    {mostrarTces && <ul className="subitens">{tces.map(renderTribunal)}</ul>}
                  </li>
                </ul>
              )}
            </J.Colunas>
          </J.Tribunais>
        )}
        <J.FiltroLinha>
          <span>Filtrar por:</span>
          <button
            type="button"
            className={mostrarFiltro ? 'ativo' : ''}
            onClick={() => setMostrarFiltro(!mostrarFiltro)}
          >
            Tribunal
            {marcados.length < tribunais.length ? ` (${marcados.length}/${tribunais.length})` : ''}
          </button>
        </J.FiltroLinha>
        <Shell.InputBar
          onSubmit={(event) => {
            event.preventDefault();
            pesquisar();
          }}
        >
          <i className="material-icons">search</i>
          <textarea
            rows={1}
            value={busca}
            placeholder="Pesquise jurisprudências no Dr. Licita"
            onChange={(event) => setBusca(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                pesquisar();
              }
            }}
          />
          <J.Categoria value={tipo} onChange={(event) => setTipo(Number(event.target.value))}>
            {LegislationsOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </J.Categoria>
          <button type="submit" disabled={!busca.trim() || marcados.length === 0}>
            <i className="material-icons">search</i>
          </button>
        </Shell.InputBar>
      </Shell.InputRegion>
      <Shell.Disclaimer>
        Busca unificada no acervo curado da ConLicitação e nas decisões coletadas do JusBrasil.
      </Shell.Disclaimer>
    </>
  );

  const renderConteudo = () => {
    if (itemAberto) {
      return (
        <Detalhe
          id={itemAberto}
          fonte={fonteAberta}
          onVoltar={() => navegar({ item: undefined, fonte: undefined })}
          onAbrir={abrirItem}
        />
      );
    }

    if (termo) {
      return (
        <>
          <S.Breadcrumb>
            <button type="button" title="Voltar" onClick={() => history.push(ROTA)}>
              <i className="material-icons">arrow_back</i>
              Jurisprudência Fácil
            </button>
            <span>&gt; Resultados</span>
          </S.Breadcrumb>
          <J.Topo>{renderBusca()}</J.Topo>
          <Resultados
            termo={termo}
            pagina={pagina}
            onPaginar={(proxima) => navegar({ page: proxima > 1 ? String(proxima) : undefined })}
            onAbrir={(item) => abrirItem(item.id, item.fonte)}
          />
        </>
      );
    }

    return (
      <J.Centro>
        <J.Cabecalho>
          <h2>Jurisprudência Fácil</h2>
          <p>
            Decisões dos Tribunais de Contas e do CNJ, com busca unificada no acervo curado da
            ConLicitação.
          </p>
        </J.Cabecalho>
        {renderBusca()}
      </J.Centro>
    );
  };

  return (
    <Shell.Page>
      <Shell.Sidebar>
        <h1>Dr.Licita</h1>
        <Shell.SidebarScroll>
          <Shell.SidebarButton as={Link} to="/dr_licita/chat">
            <i className="material-icons">add</i>
            Nova conversa
          </Shell.SidebarButton>
          <Shell.SidebarButton as={Link} to="/dr_licita/peticoes">
            <i className="material-icons">description</i>
            Petições
          </Shell.SidebarButton>
          <Shell.SidebarButton as={Link} to="/dr_licita/projetos">
            <i className="material-icons">folder_open</i>
            Projetos
          </Shell.SidebarButton>
          <Shell.SidebarButton as={Link} to="/dr_licita/biblioteca">
            <i className="material-icons">menu_book</i>
            Biblioteca de Prompts
          </Shell.SidebarButton>

          <h2>Acesso rápido</h2>
          {MODES.map((item) =>
            item.mode === 'jurisprudencia' ? (
              <Shell.SidebarButton key={item.mode} as={Link} to={ROTA} active>
                <i className="material-icons">{item.icon}</i>
                {item.title}
              </Shell.SidebarButton>
            ) : (
              <Shell.SidebarButton
                key={item.mode}
                as={Link}
                to={`/dr_licita/chat?mode=${item.mode}`}
              >
                <i className="material-icons">{item.icon}</i>
                {item.title}
              </Shell.SidebarButton>
            ),
          )}
        </Shell.SidebarScroll>

        <Shell.SidebarFooter>
          <button type="button" title="Em breve">
            <i className="material-icons">play_circle_outline</i>
            Veja como funciona
          </button>
        </Shell.SidebarFooter>
      </Shell.Sidebar>

      <Shell.Main>
        <J.Area ref={areaRef}>{renderConteudo()}</J.Area>
      </Shell.Main>
    </Shell.Page>
  );
};

export default DrLicitaJurisprudencia;
